import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showModal } from 'appSrc/redux/actions';
import { parseYouTubeUrl } from 'appSrc/utils/video';
import style from './styles/style.module.css';

class ReviewSubcard extends PureComponent {
    playMovie = () => {
        const { review } = this.props;
        var video = review.video_url;
        var videoId;
        if( video ) {

            const movieMetaData = {
                attached_to: 'review_video',
                attached_id: review.id,
                video_author_id: review.userid,
            };

            videoId = parseYouTubeUrl( video );
            this.props.playMovie( videoId, movieMetaData );
        }
    }
    render() {
        const { review } = this.props;
        var video = review.video_url;
        var videoId;
        if( video ) {
            videoId = parseYouTubeUrl( video );
        }

        const className = `${ style.subCard } ${ style.reviewCard } ${ this.props.className }`.trim();

        return (
            <div className={ className } onClick={ this.playMovie } data-clickable={ !!videoId }>
                <div className={ style.text }>
                    Watch Full Review
                </div>
            </div>
        );
    }
}
ReviewSubcard.defaultProps = {
    review: {},
    className: '',
};
ReviewSubcard.propTypes = {
    review: PropTypes.object.isRequired,
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        playMovie: ( youtubeId, metaData ) => {
            dispatch( showModal( 'movieTheater', { youtubeId: youtubeId, metaData: metaData } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( ReviewSubcard );
